import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import authApi from '../../redux/api/auth';

export const initialState = {
  token: '',
  status: 'idle',
};

export const requestRefreshToken = createAsyncThunk(
  'refreshToken',
  async (data) => {
    const { refreshToken } = data;
    const response = await authApi.postAuthRefreshToken(refreshToken);

    localStorage.setItem('token', response.token);
    Cookies.set('refreshToken', response.refreshToken, { expires: 7 });

    return response;
  }
);

export const authenticate = createAsyncThunk('signIn', async (data) => {
  const { username, password } = data;
  const signIn = await authApi.postAuthSignIn(username, password);
  if (signIn.token) {
    toast.success('Logged in successfully');
  }

  localStorage.setItem('token', signIn.token);
  Cookies.set('refreshToken', signIn.refreshToken, { expires: 7 });

  return signIn;
});

export const postLogout = createAsyncThunk('Logout', async (data) => {
  const { token } = data;
  const logOut = await authApi.postLogout(token);
  return logOut;
});

export const authSignInSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //sign in
    builder.addCase(authenticate.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(authenticate.fulfilled, (state, action) => {
      state.status = 'idle';
      state.token = action.payload;
    });
    builder.addCase(authenticate.rejected, (state) => {
      state.status = 'failed';
      state.token = [];
      toast.error('Incorrect username or password');
    });

    //log out
    builder.addCase(postLogout.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(postLogout.fulfilled, (state, action) => {
      state.status = 'idle';
      state.token = action.payload;
    });
    builder.addCase(postLogout.rejected, (state) => {
      state.status = 'failed';
      state.token = [];
    });

    // requestRefreshToken
    builder.addCase(requestRefreshToken.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(requestRefreshToken.fulfilled, (state, action) => {
      state.refreshToken = action.payload;
    });
    builder.addCase(requestRefreshToken.rejected, (state) => {
      state.refreshToken = [];
      toast.error('Error');
    });
  },
});

export default authSignInSlice.reducer;
